import { ApostleBountyFilterInput, ApostleClassType } from '@apeiron/apostle'
import BountyClassFilterSection from '@src/components/apostles/bounty/filters/BountyClassFilterSection'
import BountyOtherFilterSection from '@src/components/apostles/bounty/filters/BountyOtherFilterSection'
import ApostleSkillFilter from '@src/components/apostles/list/filter/ApostleSkillFilter'
import { ApostleSkillsProvider } from '@src/contexts/apostle/ApostleSkillsContext'
import { FC, useCallback } from 'react'

const ApostleBountyFilter: FC<Props> = (props: Props) => {
  const { apostleBountyFilterInput, setApostleBountyFilterInput } = props

  const handleClassChange = useCallback(
    (value: ApostleClassType[]) => {
      setApostleBountyFilterInput({
        ...apostleBountyFilterInput,
        classes: value ?? undefined
      })
    },
    [apostleBountyFilterInput, setApostleBountyFilterInput]
  )

  const handleSkillFilterChange = useCallback(
    (filter: ApostleBountyFilterInput) => {
      setApostleBountyFilterInput({
        ...apostleBountyFilterInput,
        firstSkillIDs: filter.firstSkillIDs,
        otherSkillIDs: filter.otherSkillIDs
      })
    },
    [apostleBountyFilterInput, setApostleBountyFilterInput]
  )

  return (
    <>
      <BountyClassFilterSection
        onFilterChange={handleClassChange}
        value={apostleBountyFilterInput.classes}
      />
      <ApostleSkillsProvider>
        <ApostleSkillFilter
          filterInput={apostleBountyFilterInput}
          onFilterChange={handleSkillFilterChange}
        />
      </ApostleSkillsProvider>
      <BountyOtherFilterSection
        filterInput={apostleBountyFilterInput}
        onFilterChange={setApostleBountyFilterInput}
      />
    </>
  )
}

type Props = {
  apostleBountyFilterInput: ApostleBountyFilterInput
  setApostleBountyFilterInput: (filterInput: ApostleBountyFilterInput) => void
}

export default ApostleBountyFilter
